<template>
  <div :class="['accordionPanel', { open: showPanel }]">
    <button
      :arial-controls="'content-' + id"
      :id="'accordion-control-' + id"
      @click.prevent="togglePanel"
      :class="['accordionToggle', { active: showPanel }]"
    >
      <span :class="['title', { hasIconLeft: iconPosition === 'left' }]">
        <span class="icon"
          ><svg
            viewBox="0 0 10 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.244078 0.244139C0.569515 -0.0812982 1.09715 -0.0812982 1.42259 0.244139L5 3.82155L8.57741 0.244139C8.90285 -0.0812982 9.43049 -0.0812982 9.75592 0.244139C10.0814 0.569576 10.0814 1.09721 9.75592 1.42265L5.58926 5.58932C5.26382 5.91475 4.73618 5.91475 4.41074 5.58932L0.244078 1.42265C-0.0813592 1.09721 -0.0813592 0.569576 0.244078 0.244139Z"
              fill="currentColor"
            /></svg
        ></span>
        {{ !showPanel ? title : activeTitle ?? title }}
      </span>
    </button>
    <div
      :aria-hidden="!showPanel"
      :id="'content-' + id"
      class="accordionContent"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "Accordion",
  props: ["id", "title", "activeTitle", "ariaTitle", "iconPosition"],
  data() {
    return {
      showPanel: ref(false)
    };
  },
  methods: {
    togglePanel: function() {
      this.showPanel = !this.showPanel;

      const accordionContent = this.$el.querySelector(".accordionContent");
      if (this.showPanel) {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
      } else {
        accordionContent.style.maxHeight = null;
      }
    },
    hidePanel: function() {
      if (this.showPanel === true) {
        this.togglePanel();
      }
    },
    activatePanel: function() {
      if (this.showPanel === false) {
        this.togglePanel();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.accordionPanel {
  --accordionIconSize: 0.9rem;
  width: 100%;

  .accordionToggle {
    position: relative;
    z-index: 2;
    padding: 0;
    margin: 0;
    width: 100%;
    background-color: transparent;
    border: none;
    font-size: 1em;
    font-weight: var(--fontWeightBold);
    letter-spacing: 0;
    color: var(--gray);
    text-transform: none;
    text-align: left;
    cursor: pointer;

    &::after {
      content: "";
      display: block;
      height: 2px;
      background-color: var(--magnolia);
      position: absolute;
      z-index: -1;
      top: 50%;
      right: 0;
      left: 0;

      .course &,
      .courseDetails & {
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
      }
    }

    .title {
      position: relative;
      display: inline-block;
      background-color: var(--white);
      padding-right: calc(0.5rem + var(--accordionIconSize) + 1rem);

      .icon {
        position: absolute;
        top: 0;
        right: 1rem;
        bottom: 0;
        color: var(--midGray);

        svg {
          width: var(--accordionIconSize);
          height: auto;
          vertical-align: middle;
          transition: transform 0.2s ease-in-out;
        }
      }

      &.hasIconLeft {
        padding-right: 1rem;
        padding-left: calc(var(--accordionIconSize) + 0.5rem);

        .icon {
          right: unset;
          left: 0;
        }
      }
    }

    &.active {
      &::after {
        opacity: 1;
      }

      .icon svg {
        transform: rotate(-180deg);
      }
    }
  }

  .accordionContent {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
  }
}
</style>
